import gql from 'graphql-tag';

import type { UserSettings } from 'src/data/user';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_USER_SETTINGS } from './schema';

const MUTATION = gql`
  mutation UpdateExtensionSettings($extensionCustomerId: ID, $extensionWorkspaceId: ID) {
    updateUserSettings(
      extensionCustomerId: $extensionCustomerId
      extensionWorkspaceId: $extensionWorkspaceId
    ) {
      ...UserSettings
    }
  }
  ${FRAGMENT_USER_SETTINGS}
`;

interface Params {
  extensionCustomerId?: ID;
  extensionWorkspaceId?: ID;
}

interface Options {
  abortSignal?: AbortSignal;
}

export const updateExtensionSettings = async (
  { extensionCustomerId, extensionWorkspaceId }: Params,
  options?: Options
) => {
  const variables = { extensionCustomerId, extensionWorkspaceId };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  return getSingleProp<UserSettings>(result.data);
};
